import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response, Http } from '@angular/http';
import { ICommonService } from "../contracts/common.service.contract";
import { Month } from "../model/month.model";
import { SettingsBasic } from "../model/settings-basic.model";
import { Observable } from "rxjs/Observable";
import { SettingsMultipleShelf } from '../model/settings-multiple-shelf.model';
import { SettingsShelfBoxRange } from '../model/settings-shelfbox-range.model';
import { SlotRequest } from '../model/slot-request.model';
import { Slot } from '../model/slot.model';
import { ShelfLedsConfig } from '../model/shelf-leds-config.model';
import { ShelfBoxLedsRange } from '../model/shelf-box-leds-range.model';
import { Account } from 'app/+auth/common/model/account.model';

@Injectable()
export class CommonService implements ICommonService
{
    private _backendUrl;
    private _instanceType;    

    constructor(private http: HttpClient, private httpOld: Http)
    {
        this.httpOld.get('assets/configuration/environment.json')
            .map(res => res.json())
            .toPromise()
            .then((config) =>
            {
                this.backendUrl = config.url;
                this.instanceType = config.env;
                localStorage.setItem("backendURL", config.url);
                localStorage.setItem("exaco-instance-type", config.env);

                console.log(config.url);
                console.log(config.env);
            });
    }

    get backendUrl(): string
    {
        return localStorage.getItem("backendURL");
    }
    set backendUrl(url: string)
    {
        this._backendUrl = url;
    }
    get instanceType(): string
    {
        if (this._instanceType && this._instanceType != "")
            return this._instanceType;
        else
            return localStorage.getItem("exaco-instance-type");
    }
    set instanceType(type: string)
    {
        this._instanceType = type;
    }

    getYearList(): number[] 
    {
        let years: number[] = [2018,2019,2020,2021,2022];
        return years;
    }

    getMonthList() : Month[]
    {
        let months: Month[]= [

            {ordinal: 1, name: 'gennaio'},
            {ordinal: 2, name: 'febbraio'},
            {ordinal: 3, name: 'marzo'},
            {ordinal: 4, name: 'aprile'},
            {ordinal: 5, name: 'maggio'},
            {ordinal: 6, name: 'giugno'},
            {ordinal: 7, name: 'luglio'},
            {ordinal: 8, name: 'agosto'},
            {ordinal: 9, name: 'settembre'},
            {ordinal: 10, name: 'ottobre'},
            {ordinal: 11, name: 'novembre'},
            {ordinal: 12, name: 'dicembre'}
        ];
        return months;
    }

    getBasicSettings(): Observable<SettingsBasic[]>
    {
        return this.http.get(this.backendUrl + "settings")
            .map(this.extractData)
            .catch(this.handleError);
    }

    setBasicSettings(settings: SettingsBasic[]): Observable<any>
    {
        return this.http.post(this.backendUrl + "settings", settings)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getBasicSetting(key: string): Observable<SettingsBasic>
    {
        return this.http.get(this.backendUrl + "settings/" + key)
        .map(this.extractData)
        .catch(this.handleError);
    }

    getShelfSettings(): Observable<SettingsMultipleShelf[]>
    {
        return this.http.get(this.backendUrl + "settings/multiple-shelf")
            .map(this.extractData)
            .catch(this.handleError);
    }

    setShelfSettings(settings: SettingsMultipleShelf[]): Observable<any>
    {
        return this.http.post(this.backendUrl + "settings/multiple-shelf", settings)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getShelfBoxLightsSettings(): Observable<ShelfBoxLedsRange[]>
    {
        return this.http.get(this.backendUrl + "settings-lights")
            .map(this.extractData)
            .catch(this.handleError);
    }

    setShelfBoxLightsSettings(settings: ShelfBoxLedsRange[]): Observable<any>
    {
        return this.http.post(this.backendUrl + "settings-lights", settings)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getShelfBoxRangeSettings(): Observable<SettingsShelfBoxRange[]>
    {
        return this.http.get(this.backendUrl + "settings/shelfbox-range")
            .map(this.extractData)
            .catch(this.handleError);
    }

    setShelfBoxRangeSettings(settings: SettingsShelfBoxRange[]): Observable<any>
    {
        return this.http.post(this.backendUrl + "settings/shelfbox-range", settings)
            .map(this.extractData)
            .catch(this.handleError);
    }

    setLightShelfBox(boxNumber, deviceUrl: string)
    {
        let slotRequest = new SlotRequest();
        let slots = new Array<Slot>();
        let box = new Slot();
        box.color = "#00FF00";
        box.position = boxNumber;

        slots[0] = box;
        slotRequest.slots = slots;

        return this.http.post(deviceUrl + "slots", slotRequest)
            .map(this.extractData)
            .catch(this.handleError).subscribe(err => this.handleError);
    }

    setShelfLights(deviceUrl: string, configuration: ShelfLedsConfig): Observable<any>
    {
        return this.http.post(deviceUrl + "configure", configuration)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getAccountList(): Observable<Account[]> {
        return this.http.get(this.backendUrl + "accounts")
            .map(this.extractData)
            .catch(this.handleError);
    }

    setAccount(account: Account): Observable<any> {
        return this.http.post(this.backendUrl + "accounts", account)
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: any)
    {
        let body = res; //.json();
        return body;// || {};
    }
    private handleError(error: Response | any)
    {
        // In a real world app, you might use a remote logging infrastructure
        let errMsg: string;
        if (error instanceof Response)
        {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${ error.status } - ${ error.statusText || '' } ${ err }`;
        }
        else
        {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }
}


// WEBPACK FOOTER //
// ./src/app/+common/services/common.service.ts